<div mat-dialog-title class="_pay-dialog-title">
	<span class="_cap">{{'KashCash' | translate}}</span>
	<button mat-icon-button mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<iframe class="embed-responsive-item panel"
		style="	border: 0; height: calc(100vh - 140px); overflow: hidden;"
		[src]="this.trustedIframeUrl"></iframe>
